import { SportAbrv } from "@utils/common";

export const PERIOD_SPORTS = new Set<string>([
	SportAbrv.ICE_HOCKEY,
	SportAbrv.TENNIS,
	SportAbrv.TABLE_TENNIS,
	SportAbrv.VOLLEYBALL,
	SportAbrv.BEACH_VOLLEY,
	SportAbrv.BASEBALL,
	SportAbrv.DARTS,
	SportAbrv.SNOOKER,
	SportAbrv.AMERICAN_FOOTBALL,
	SportAbrv.AUSSIE_RULES,
	SportAbrv.WATERPOLO,
	SportAbrv.BADMINTON,
]);
